import React, { Component } from "react";
import ReactDOM from 'react-dom'; 
import axios from "axios";
import { LangContext } from "../LangContext.jsx";
import SimplePagination from "./SimplePagination";
class SuspendRecurrencyModal extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.currentHistoryId = 0;
        this.state = { 
            documents:[],
            selectedDocuments:[],
            page: 1,
            search:'',
            pageOnce:1,
            maxRecords: 10,
            total: 0,
        }; 
        this.handleOpenModalSuspend = this.handleOpenModalSuspend.bind(this);
    } 

    updateCurrentPage = async (page)=>{
        await this.setState({page: page}, function () {
            this.getDocuments();
        });
    } 
    async getDocuments(){ 
        var url = '/api/dossiers/dossier_documents/'+this.props.person_provider_id;
        const query = new URLSearchParams();
        query.append('state', this.props.from_document_dossier_update_state)
        query.append('page', this.state.page)
        query.append('search', this.state.search)
        query.append('maxRecords', this.state.maxRecords) 
        const qs = query.toString();
        url = url + `?${qs}`;
        url = url.endsWith('/') ? url.slice(0, -1) : url; 
        await axios.get(url).then(res=>{
            const data = res.data.data; 
            this.setState({documents:data ,total: res.data.total}) 
        }); 
    }

    handleOpenModalSuspend() {  
        this.setState({selectedDocuments: []}) 
        this.getDocuments() 
    }

    isChecked = (e)=>{    
        console.log('ischeked' + e.document.id)
        for(let i=0; i<this.state.selectedDocuments.length; i++){
            if(this.state.selectedDocuments[i].document.id == e.document.id){
                console.log('ischeked' + e.document.id)
                return true;
            }
        } 
    }

    sendEvent = () =>{ 
        const { lang } = this.context; 
        axios.post('/api/documents/update/'+this.props.person_provider_id+'/masive',{
            ids:this.state.selectedDocuments,
            state:this.props.document_dossier_update_state
        }).then(res=>{
            swal.fire({
                text: lang.get('messages.documentos_actualizados'),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText:lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            }).then(function(result) {
                location.reload()
            });
        })
    }

    handleChange(e){
        this.setState({search: e.target.value, page: 1}, function () {
            this.getDocuments();
        });
    }

    updateStateList(e, value){
        if (e.target.checked){
                this.setState({
                    selectedDocuments: this.state.selectedDocuments.concat([value])
                })
            } else {
            this.setState({
                selectedDocuments : this.state.selectedDocuments.filter(function(val)
                    {
                        return val.id!==value.id
                    }
                )
            })
        }
    }
    render() {
        const { lang } = this.context;
        
        return (<div className="modal fade"   id="suspendModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalSizeSm" arian-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                        <div className="modal-content" style={{ background: '#f5f5f5' }}>
                        <div className="modal-body px-15 py-10"> 
                        <h5 className="text-dark font-weight-bold my-1 mr-5">
                        {this.props.document_dossier_update_state == 2 && lang.get('messages.suspender_recurrencia') }
                        {this.props.document_dossier_update_state == 1 &&  lang.get('messages.reactivar_recurrencia') }  </h5>
                            <div className="text-muted">
                                {this.props.document_dossier_update_state == 2 && lang.get('messages._selecciona_las_plantillas_de_documentos_en_las_que_deseas_suspender_la_recurrencia_asignada') }
                                {this.props.document_dossier_update_state == 1 && lang.get('messages._selecciona_las_plantillas_de_documentos_en_las_que_deseas_reactivar_la_recurrencia_asignada') }
                            </div>
                            <div className="card card-custom gutter-b my-5">
                                <div className="card-header border-0 pt-6">
                                    <h3 className="col-8 card-title align-items-start flex-column">
                                        <span className="card-label font-weight-bolder font-size-h4 text-dark-75">{lang.get('messages.tipos_de_documentos')}</span>
                                        <span className="text-muted mt-3 font-weight-bold font-size-lg">{this.state.total} {lang.get('messages.documentos_disponibles')}</span>
                                    </h3>
                                    <div className="row col-4 justify-content-end">
                                        <div className="col-12">
                                            <div className="input-icon">
                                                <input onChange={(e)=>this.handleChange(e)} name="search"type="text" className="form-control" placeholder={lang.get('messages.buscar')} />
                                                <span>
                                                    <i className="flaticon2-search-1 text-primary icon-md"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body pt-5">
                                    {this.state.documents.map((o, i) => {
                                    return <div key={i}>
                                    <div className="d-flex align-items-center py-2 mb-5">
                                        <div className="symbol symbol-40 symbol-white">
                                            <span className="symbol-label d-flex justify-content-start w-45px ml-n1">
                                            <div className="checkbox-inline mr-5">
                                                <label className="checkbox checkbox-outline mb-7">
                                                    <input key={o}
                                                    name='list'
                                                    type='checkbox' 
                                                    label='Add'
                                                    checked={this.isChecked(o)}
                                                    onClick={(e)=>this.updateStateList(e,o)}
                                                    className='listTour'/>
                                                    <span className="w-25px h-25px mt-2 rounded-0"></span>
                                                </label>
                                            </div>
                                            </span>
                                        </div>
                                        <div className="d-flex   flex-grow-1 my-lg-0 my-2 mr-2">
                                        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                <rect x="0" y="0" width="24" height="24" />
                                                <path d="M5,3 L6,3 C6.55228475,3 7,3.44771525 7,4 L7,20 C7,20.5522847 6.55228475,21 6,21 L5,21 C4.44771525,21 4,20.5522847 4,20 L4,4 C4,3.44771525 4.44771525,3 5,3 Z M10,3 L11,3 C11.5522847,3 12,3.44771525 12,4 L12,20 C12,20.5522847 11.5522847,21 11,21 L10,21 C9.44771525,21 9,20.5522847 9,20 L9,4 C9,3.44771525 9.44771525,3 10,3 Z" fill="#844AFF" />
                                                <rect fill="#000000" opacity="0.3" transform="translate(17.825568, 11.945519) rotate(-19.000000) translate(-17.825568, -11.945519)" x="16.3255682" y="2.94551858" width="3" height="18" rx="1" />
                                            </g>
                                        </svg>
                                        <div className="d-flex flex-column ml-5">
                                            
                                            <a href={"/documents/" + o.document.id + "/edit"} 
                                            
                                            className={"text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg " + (o.document.active==0 ? "text-muted" : "")}>{o.document.fields.length > 0 && <span className="text-danger font-weight-bold">* </span> }{o.document.title} {o.document.fields.length > 0 && <span className="text-muted font-weight-normal">
                                                ( {lang.get('messages.con_informacion_adicional')})</span> }
                                            </a>
                                            <span className="text-muted font-weight-bold">{o.document.frequency == 'once' ? 'Único' : 'Recurrente'} |&nbsp;
                                                {
                                                    o.document.mimes.map((mime, i, {length}) => {
                                                        if (length - 1 === i) {
                                                            return mime.mime.toUpperCase()
                                                        } else {
                                                            return mime.mime.toUpperCase() + ', '
                                                        }
                                                    })
                                                }
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div> })} 
                        </div>
                    </div>
                                {this.state.total > this.state.maxRecords &&
                                        <SimplePagination
                                            updateCurrentPage={this.updateCurrentPage}
                                            currentPage={this.state.page}
                                            totalFiles={this.state.total}
                                            split={this.state.maxRecords}
                                        />
                                    } 
                            <br />
                            <div className="text-center">
                                <button
                                    className="btn btn-success font-weight-bolder px-10"
                                    disabled={this.state.selectedDocuments.length == 0}
                                    onClick={() => this.sendEvent()}
                                >
                                    {this.props.document_dossier_update_state == 2 && lang.get('messages.suspender_recurrencia') }
                                    {this.props.document_dossier_update_state == 1 &&  lang.get('messages.reactivar_recurrencia') }
                                </button>
                            </div>  
                        </div>
                        </div>
                    </div>
                </div>);
    }
}

export default SuspendRecurrencyModal;

if (document.getElementById('SuspendRecurrencyModal')) {
    ReactDOM.render(<SuspendRecurrencyModal />, document.getElementById('SuspendRecurrencyModal'));
}
